<ion-header>
  <ion-toolbar color="dark">
    <ion-buttons slot="start">
      <ion-button (click)="closeModal()"> <ion-icon slot="icon-only" name="close"></ion-icon> </ion-button>
    </ion-buttons>
    <ion-title translate paramdata="Image"></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [forceOverscroll]="false" color="dark" fullscreen="true">
  <div class="swiper-zoom-container" style="height: 100%;"><img [src]="imgSource" style="width: 100%; height: 98%;" /></div>
</ion-content>